<template>
  <div class="space-y-2">
    <div class="flex items-center gap-2">
      <select class="select select-bordered select-sm w-full" v-model="current" @change="apply">
        <option v-for="t in themes" :key="t" :value="t">{{ t }}</option>
      </select>
      <button class="btn btn-sm" @click="reset">Reset</button>
    </div>
    <div class="grid grid-cols-6 gap-2">
      <button
        v-for="t in themes"
        :key="t + '-btn'"
        class="btn btn-xs"
        @click="setTheme(t)"
        :title="t"
      >
        {{ t.substring(0, 3) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue'
  import { SUPPORTED_THEMES as themes, applyTheme, getSavedTheme, initTheme } from '@/utils/theme'

  const current = ref<string>('system')

  function setTheme(theme: string) {
    current.value = theme
    applyTheme(theme)
  }

  function apply() {
    setTheme(current.value)
  }

  function reset() {
    setTheme('system')
  }

  onMounted(() => {
    const saved = getSavedTheme()
    if (saved) {
      current.value = saved
      applyTheme(saved)
    } else {
      initTheme(true)
      current.value = 'system'
    }
  })
</script>
